import Lottie from 'react-lottie'

import { track, useTracking } from 'lib/analytics'
import { createBirthdayWishlistPath } from 'lib/urls'
import { InfoButton } from 'components/buttons'
import ConfettiFade from 'shared/lottie/ConfettiFade.lottie.json'
import Close from 'shared/svg/close.svg'
import css from './BirthdayWishlistModal.styles.scss'
import { Responses } from '../../global'

interface BirthdayWishlistModalProps {
  closeModal: () => void
  eventLocation: string
  registry: Responses.Registry
}

const BirthdayWishlistModal = ({
  closeModal,
  eventLocation,
  registry,
}: BirthdayWishlistModalProps) => {
  const { trackEvent } = useTracking()

  const handleCtaClick = () => {
    trackEvent({
      event: track.listTypeClicked,
      eventLocation,
      listType: track.ListType.BIRTHDAY,
      registryId: registry.id,
      registryOwnerId: registry.ownerId,
    })

    setTimeout(() => {
      window.location.href = createBirthdayWishlistPath
    }, 100)
  }

  return (
    <div className={css.BirthdayWishlistModal}>
      <div className={css.BirthdayWishlistModal__contentWrapper}>
        <div
          className={`${css.BirthdayWishlistModal__imageWrapper} ${css.BirthdayWishlistModal__imageWrapper__desktop}`}
        >
          <div className={css.BirthdayWishlistModal__confetti}>
            <Lottie
              options={{ animationData: ConfettiFade }}
              title="Confetti Animation"
            />
          </div>

          <img
            alt="Cupcake"
            className={css.BirthdayWishlistModal__cupcake}
            src="https://images.babylist.com/image/upload/v1693955235/icons/cupcake.png"
          />
        </div>

        <div className={css.BirthdayWishlistModal__details}>
          <button
            className={css.BirthdayWishlistModal__closeButton}
            data-testid="close-button"
            title="Close Birthday Wishlist Modal"
            type="button"
            onClick={closeModal}
          >
            <Close />
          </button>

          <div className={css.BirthdayWishlistModal__title}>
            Birthday Gifts Made Easy
          </div>

          <div
            className={`${css.BirthdayWishlistModal__imageWrapper} ${css.BirthdayWishlistModal__imageWrapper__mobile}`}
          >
            <div className={css.BirthdayWishlistModal__confetti}>
              <Lottie options={{ animationData: ConfettiFade }} />
            </div>

            <img
              alt="Cupcake"
              className={css.BirthdayWishlistModal__cupcake}
              src="https://images.babylist.com/image/upload/v1693955235/icons/cupcake.png"
            />
          </div>

          <div
            aria-hidden="true"
            className={css.BirthdayWishlistModal__subtitle}
          >
            Dreading gifts with 100s of pieces? Create a wishlist for what they
            really need instead!
          </div>

          <div className="visually-hidden">
            Dreading gifts with 100s of pieces? Create a wishlist for what they
            really need instead!
          </div>
        </div>
      </div>

      <div className={css.BirthdayWishlistModal__ctaContainer}>
        <InfoButton
          pill
          className={css.BirthdayWishlistModal__ctaButton}
          onClick={handleCtaClick}
        >
          Start a Birthday Wishlist
        </InfoButton>
      </div>
    </div>
  )
}

export default BirthdayWishlistModal
